/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import windowRoot from 'window-or-global';
import { h } from 'preact';
import { useState, useRef, useLayoutEffect } from 'preact/hooks';
import { Box, Button, Card, Dialog, Grid, Tooltip } from '@mui/material';
// @ts-ignore
import { toast } from 'react-toastify';
// import ReactQuill from 'react-quill';

import { LoadingButton } from '@mui/lab';
import Preview, { IPreviewHadle } from './components/preview';
import Edit from './components/edit';
import Signet from './components/signet';
import useUserActions from '../../hooks/useUserActions';
import usePageType from '../../hooks/usePageType';
import { getIsMobile } from '../../utils/tools';

import {
  quitData,
  practiceData,
  incomeData,
  workData,
  commonData,
} from '../../apis/templateData';

type IImportType = '' | 'quit' | 'work' | 'practice' | 'income' | 'common';

export interface IBaseInfo {
  width: number;
  height: number;
  marginTop: number;
  padding: number;
  backgroundColor: string;
  title: string;
  titleFontFamily: string;
  titleFontSize: number;
  titleFontColor: string;
  titleMarginBottom: number;
  content: string;
  contentFontFamily: string;
  contentFontSize: number;
  contentFontColor: string;
  contentLineHeight: number;
  rbContent1: string;
  rbContent2: string;
  rbContentFontFamily: string;
  rbContentFontSize: number;
  rbContentFontColor: string;
  rbContentLineHeight: number;
  rbRight: number;
  rbBottom: number;
}

export interface ISignetInfo {
  size: number; // 大小
  offsetX: number; // 盖章位置X
  offsetY: number; // 盖章文字Y
  borderColor: string; // 边框颜色
  content: string; // 环形文字内容
  contentSize: number;
  contentFamily: string; // 环形文字字体
  contentColor: string; // 环形文字颜色
  describe: string; // 描述
  describeSize: number; // 描述大小
  describeColor: string; // 描述颜色
  describeFamily: string;
  rotate: number;
  opacity: number;
  abrasion: number;
}

export type IEditType = 'base' | 'signet';

const Stamp = () => {
  const { isLogin, isVip } = useUserActions();
  const previewContainerRef = useRef<IPreviewHadle>(null);
  const [editType, setEditType] = useState<IEditType>('signet');
  const [isDownloading, setIsDownloading] = useState(false);
  const [isWatermarkRemoval, setIsWatermarkRemoval] = useState(false);
  const [isRealTime, setIsRealTime] = useState(true);
  const [isShowImportType, setIsShowImportType] = useState(false);
  const [baseInfo, setBaseInfo] = useState<IBaseInfo>(quitData.baseInfo);

  const [signetInfo, setSignetInfo] = useState<ISignetInfo>(
    quitData.signetInfo
  );

  const pageType = usePageType();

  useLayoutEffect(() => {
    switch (pageType) {
      case 'quit':
        setBaseInfo(quitData.baseInfo);
        setSignetInfo(quitData.signetInfo);
        break;

      case 'work':
        setBaseInfo(workData.baseInfo);
        setSignetInfo(workData.signetInfo);
        break;

      case 'practice':
        setBaseInfo(practiceData.baseInfo);
        setSignetInfo(practiceData.signetInfo);
        break;

      case 'income':
        setBaseInfo(incomeData.baseInfo);
        setSignetInfo(incomeData.signetInfo);
        break;

      case 'common':
        setBaseInfo(commonData.baseInfo);
        setSignetInfo(commonData.signetInfo);
        break;
    }
  }, [pageType]);

  useLayoutEffect(() => {
    setEditType('base');
  }, []);

  useLayoutEffect(() => {
    setIsWatermarkRemoval(isVip);
    // setIsRealTime(isVip);
  }, [isVip]);

  const onChangeBaseInfo = (name: keyof typeof baseInfo) => (e: any) => {
    if (name === 'width') {
      if (e.target.value > 2000) {
        toast('宽度不能大于2000px!', { type: 'warning' });
        return;
      }
    }

    if (name === 'height') {
      if (e.target.value > 2000) {
        toast('高度不能大于2000px!', { type: 'warning' });
        return;
      }
    }

    setBaseInfo((_baseInfo) => ({ ..._baseInfo, [name]: e.target.value }));
  };

  const onChangeSignetInfo = (name: keyof typeof signetInfo) => (v: any) => {
    setSignetInfo((signetInfo) => ({ ...signetInfo, [name]: v }));
  };

  const checkVip = () => {
    if (!isVip) {
      toast('您不是VIP会员，不支持该功能!', { type: 'warning' });
      throw new Error('您不是VIP会员，不支持该功能!');
    }
  };

  const handleWatermarkRemoval = () => {
    if (!isLogin) return toast('请先登录~', { type: 'warning' });
    checkVip();
    setIsWatermarkRemoval(true);
    windowRoot.setTimeout(() => {
      previewContainerRef.current?.runPreview();
      toast('水印去除成功。', { type: 'success' });
    }, 200);
  };

  const hanldeRealTimeUpdate = () => {
    if (!isLogin) return toast('请先登录~', { type: 'warning' });
    checkVip();
    setIsRealTime(!isRealTime);
    toast(!isRealTime ? '已开启。' : '已关闭。', { type: 'success' });
  };

  const handleUpdate = () => {
    // if (!isLogin) return toast('请先登录~', { type: 'warning' });
    previewContainerRef.current?.runPreview();
    toast('已更新。', { type: 'success' });
  };

  const handleDownload = () => {
    if (getIsMobile()) {
      previewContainerRef.current?.downloadImageCloude(
        '离职证明',
        setIsDownloading
      );
    } else {
      previewContainerRef.current?.downloadImage('离职证明');
    }
    // if (!isLogin) return toast('请先登录~', { type: 'warning' });
    // toast('正在下载。', { type: 'success' });
  };

  const importTemplate = () => {
    setIsShowImportType(true);
  };

  const handleImportTemplate = (type: IImportType) => {
    setIsShowImportType(false);

    switch (type) {
      case 'quit':
        setBaseInfo(quitData.baseInfo);
        setSignetInfo(quitData.signetInfo);
        break;
      case 'work':
        setBaseInfo(workData.baseInfo);
        setSignetInfo(workData.signetInfo);
        break;
      case 'practice':
        setBaseInfo(practiceData.baseInfo);
        setSignetInfo(practiceData.signetInfo);

        break;
      case 'income':
        setBaseInfo(incomeData.baseInfo);
        setSignetInfo(incomeData.signetInfo);
        break;

      case 'common':
        setBaseInfo(commonData.baseInfo);
        setSignetInfo(commonData.signetInfo);
        break;

      default:
        break;
    }

    toast('导入成功！', { type: 'success' });
  };

  return (
    <div
      style={{
        padding: '20px',
        paddingTop: 0,
        minHeight: 'calc(100% - 52px)',
        width: '100%',
        fontFamily: 'Courier New, Courier, monospace',
      }}
    >
      <Dialog
        open={isShowImportType}
        onClose={() => setIsShowImportType(false)}
        PaperProps={{ sx: { margin: '10px' } }}
        TransitionProps={{ style: { alignItems: 'start', marginTop: '15vh' } }}
      >
        <Box
          sx={{
            padding: 2,
            display: 'flex',
            justifyItems: 'center',
            flexWrap: 'wrap',
          }}
        >
          {[
            { title: '离职证明模板', color: 'info', type: 'quit' },
            { title: '工作证明模板', color: 'success', type: 'work' },
            { title: '收入证明模板', color: 'secondary', type: 'income' },
            { title: '实习证明模板', color: 'warning', type: 'practice' },
            // { title: '通用模板', color: 'error', type: 'common' },
          ].map((item, index) => (
            <Button
              key={index}
              variant="contained"
              color={item.color as 'info' | 'success' | 'secondary' | 'warning'}
              sx={{ margin: '10px', width: { xs: '100%', md: 'auto' } }}
              onClick={() => handleImportTemplate(item.type as IImportType)}
            >
              {item.title}
            </Button>
          ))}
        </Box>
      </Dialog>

      <Box
        a="123123"
        sx={{
          margin: '10px',
          position: { xs: 'sticky', md: 'relative' },
          display: { xs: 'block', md: 'flex' },
          top: '12px',
          justifyContent: 'center',
          alignItems: 'flex-end',
          backgroundColor: '#fff',
          zIndex: '99',
        }}
      >
        <Card
          variant="outlined"
          sx={{
            maxWidth: '100%',
            width: 700,
            height: { xs: 220, md: 350 },
            marginRight: '10px',
            marginBottom: { xs: '10px', md: 0 },
          }}
        >
          <Preview
            ref={previewContainerRef}
            isWatermarkRemoval={isWatermarkRemoval}
            isRealTime={isRealTime}
            baseInfo={baseInfo}
            signetInfo={signetInfo}
          />
        </Card>

        <Box>
          <Grid container spacing={{ xs: 2, md: 0 }}>
            <Grid item xs={6} md={12}>
              <Tooltip title="一键导入常用模板" placement="top" arrow>
                <Button
                  variant="contained"
                  color="info"
                  sx={{
                    display: 'block',
                    marginBottom: '10px',
                    width: { xs: '100%', md: 'auto' },
                  }}
                  onClick={importTemplate}
                >
                  导入常用证明模板
                </Button>
              </Tooltip>
            </Grid>
            <Grid item xs={6} md={12}>
              <Tooltip title="开通会员后自动去除水印" placement="top" arrow>
                <Button
                  variant="contained"
                  color="secondary"
                  sx={{
                    display: 'block',
                    marginBottom: '10px',
                    width: { xs: '100%', md: 'auto' },
                  }}
                  onClick={handleWatermarkRemoval}
                >
                  去除水印
                </Button>
              </Tooltip>
            </Grid>
          </Grid>

          <Tooltip title="点击后下载" placement="top" arrow>
            <LoadingButton
              loading={isDownloading}
              variant="contained"
              color="success"
              sx={{
                display: 'block',
                marginBottom: '10px',
                width: { xs: '100%', md: 'auto' },
              }}
              onClick={handleDownload}
            >
              下载图片到本地
            </LoadingButton>
          </Tooltip>

          {/* <Tooltip title="更新图片" placement="top" arrow>
            <Button
              variant="contained"
              color="info"
              sx={{ marginBottom: '10px', width: { xs: '100%', md: 'auto' } }}
              onClick={handleUpdate}
            >
              更新图片
            </Button>
          </Tooltip> */}
          {/* <Tooltip title="修改后立即更新图片" placement="top" arrow>
            <Button
              variant="contained"
              color="warning"
              sx={{ marginBottom: '10px', width: { xs: '100%', md: 'auto' } }}
              onClick={hanldeRealTimeUpdate}
            >
              {isRealTime ? '关闭实时更新图片' : '开启实时更新图片'}
            </Button>
          </Tooltip> */}
        </Box>
      </Box>

      <Box sx={{ display: 'flex', flexWrap: { xs: 'wrap', md: 'nowrap' } }}>
        <Card
          variant="outlined"
          sx={{
            p: 1,
            marginRight: { md: 1 },
            width: { xs: '100%', md: editType === 'base' ? '70%' : '30%' },
            transition: 'width 0.3s',
          }}
          onclick={() => setEditType('base')}
        >
          <p
            style={{
              textAlign: 'center',
              fontWeight: 'bold',
              padding: '8px 0',
              margin: '0',
              fontSize: 18,
              backgroundColor: '#ddd',
            }}
          >
            内容编辑
          </p>
          <Edit
            editType={editType}
            baseInfo={baseInfo}
            onChangeBaseInfo={onChangeBaseInfo}
          />
        </Card>
        <Card
          variant="outlined"
          sx={{
            p: 1,
            width: {
              xs: '100%',
              md: editType === 'signet' ? '70%' : '30%',
            },
            transition: 'width 0.3s',
          }}
          onclick={() => setEditType('signet')}
        >
          <p
            style={{
              textAlign: 'center',
              fontWeight: 'bold',
              padding: '8px 0',
              margin: '0',
              fontSize: 18,
              backgroundColor: '#ddd',
            }}
          >
            盖章编辑
          </p>
          <Signet
            editType={editType}
            signetInfo={signetInfo}
            onChangeSignetInfo={onChangeSignetInfo}
          />
        </Card>
      </Box>
    </div>
  );
};

export default Stamp;
